import React, { useState, useEffect } from 'react';
import { Input } from 'antd';
import PropTypes from 'prop-types';
import { FtoC, CtoF } from 'utils';

export const InputTemperature = ({ onChange, value, unit = 'F', ...rest }) => {
    const [temperature, setTemperature] = useState();

    useEffect(() => {
        const temp = (unit === 'C') ? FtoC(value) : value;
        setTemperature(temp);
    }, [unit, value]);

    const onBlur = () => {
        const temp = parseFloat(temperature);
        onChange((unit === 'C') ? CtoF(temp) : temp);
    };

    return (
        <Input
            {...rest}
            onChange={e => setTemperature(e.target.value)}
            inputMode="numeric"
            value={temperature}
            onBlur={onBlur}
        />
    );
};

InputTemperature.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.number,
    unit: PropTypes.string,
};
